export * from './user-dialog';
export * from './tenant-picker-list';

import { UserDialogComponent } from "./user-dialog";
import { TenantPickerListComponent } from './tenant-picker-list';

export const UserDialogOrganisms = 
[
    UserDialogComponent,     
    TenantPickerListComponent
];